// src/views/consentimientos/consentimientoApi.js
import axios from 'axios'
import config from '@/config'

const BASE = `${config.apiBaseUrl}/consentimientos`

export const consentimientoApi = {

  // Crea un consentimiento pendiente para una atención
  crear(idAtencion, codigoPlantilla) {
    return axios.post(BASE, { idAtencion, codigoPlantilla })
  },

  // Firma el consentimiento con la imagen del canvas
  firmar(idConsentimiento, payload) {
    return axios.put(`${BASE}/${idConsentimiento}/firmar`, payload)
  },

  // Lista todos los consentimientos de una atención
  listarPorAtencion(idAtencion) {
    return axios.get(`${BASE}/atencion/${idAtencion}`)
  },

  // Descarga el PDF firmado
  descargarPdf(idConsentimiento) {
    return axios.get(`${BASE}/${idConsentimiento}/pdf`, {
      responseType: 'blob'
    })
  }
}